import { type ArchiveRecordStep } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/actionSectionTypes';
import { TFunction } from 'react-i18next';
import DraggableStepCard, { DraggableStepCardProps } from '../../DraggableStepCard';

export const content = ({ step }: { step: ArchiveRecordStep }) =>
  step.description;

export const getDescription = ({
  step: { details },
  t,
}: {
  step: ArchiveRecordStep;
  t: TFunction;
}) => {
  const { recordSource, relationshipFields, automationVariable } = details;

  if (recordSource === 'automation_variable' && automationVariable) {
    return t(`Archive '{{variableName}}' Record`, {
      variableName: automationVariable.label,
    });
  }

  if (recordSource === 'related_object_field') {
    const relationshipFieldNames = relationshipFields
      .map(({ label }) => label)
      .sort((a, b) => {
        return a.localeCompare(b, 'en', { sensitivity: 'base' });
      })
      .join(', ');

    return t(`Archive 'Related Record' from '{{relationshipFieldNames}}'`, {
      relationshipFieldNames,
    });
  }

  return t(`Archive 'This Record'`);
};

export default function ArchiveRecordCard({
  step,
  ...others
}: {
  step: ArchiveRecordStep;
} & DraggableStepCardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
